import { getNotificationChannelBadge } from "../../utils/notificationChannelBadge";
import type { NotificationLogItem } from "./notificationsListQuery";

export function notificationChannelBadge(channel: NotificationLogItem["channel"]) {
  return getNotificationChannelBadge(channel);
}

export function notificationStatusBadge(status: NotificationLogItem["status"]): {
  label: string;
  className: string;
} {
  if (status === "sent") {
    return {
      label: "Enviado",
      className: "border-emerald-200 bg-emerald-50 text-emerald-800",
    };
  }

  if (status === "failed") {
    return {
      label: "Falhou",
      className: "border-red-200 bg-red-50 text-red-800",
    };
  }

  return {
    label: "Ignorado",
    className: "border-slate-200 bg-slate-100 text-slate-700",
  };
}

export function formatNotificationDate(value: string): string {
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "—";
  return date.toLocaleString("pt-BR");
}
